import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_24 } from '../../Button'
import { QA_NAME_DASHBOARD_BIRDVIEW_ROW_ACTION } from '../DashboardBirdview.constants.qa'

function BirdviewRowActionButton({
  isLoading,
  labelKey = 'Common.ClickToOpenProfileKey',
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <Button.Outlined
      height={BUTTON_HEIGHT_24}
      isLoading={isLoading}
      qaName={QA_NAME_DASHBOARD_BIRDVIEW_ROW_ACTION}
      text={t(labelKey)}
      onClick={onClick}
    />
  )
}

export default BirdviewRowActionButton
